/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from 'react';
import authRoles from '../../auth/authRoles';
import InstanceWrapper from '../../shared-components/layouts/InstanceWrapper';
import PageView from './instance/PageView';
// import Page from "./instance/PageOld";
import CommentForm from '../../shared-components/comments/CommentForm';
import ReplyForm from '../../shared-components/comments/ReplyForm';
import PageForm from './instance/PageForm';
import PageLivePreview from './instance/PageLivePreview';
import InstanceComments from '../../shared-components/InstanceComments';

const PagesConfig = {
  routes: [
    {
      path: 'pages/:id',
      element: <PageView />,
      children: [
        {
          path: 'comments',
          element: <InstanceComments category="pages" hasSidebar collection='comments' />
        },
        {
          path: 'comments/:commentId/edit',
          element: <CommentForm collection='comments' />
        },
        {
          path: 'comments/:commentId/reply/:replyId/edit',
          element: <ReplyForm collection='comments' />
        }
      ]
    },
    {
      path: 'pages/:id/edit',
      element: <InstanceWrapper />,
      auth: authRoles.editor,
      children: [
        {
          path: '',
          element: <PageForm />
        }
      ]
    }
  ]
};

export default PagesConfig;
